export enum AuthorizationLevel {
    NORMAL_ACCESS = 'normal_access',
    LIMITED_ACCESS = 'limited_access',
    NO_ACCESS = 'no_access',
}

export enum LimitedAccessScope {
    SIGNUP_CHECKOUT = 'must_complete_signup_checkout',
    SIGNUP_ONBOARDING = 'must_complete_signup_onboarding',
    MEMBERSHIP_ONBOARDING = 'must_complete_membership_onboarding',
    KYC = 'must_complete_kyc',
    BANKING = 'banking_only',
    FORMER_MEMBER = 'former_member',
    NO_ACCESS = 'no_access',
    FULL_ACCESS = 'full_access',
}

export enum RestrictedCapability {
    GUIDE_MESSAGING = 'guideMessaging',
    GUIDANCE_SESSIONS = 'guidanceSessions',
    OPEN_BANKING_ACCOUNT = 'openBankAccount',
    OPEN_INVESTMENT_ACCOUNT = 'openInvestmentAccount',
}

export type RestrictedCapabilityDictionary = Record<
    RestrictedCapability,
    boolean | null
>;

export const unknownAccessToRestrictedCapabilities: RestrictedCapabilityDictionary =
    {
        [RestrictedCapability.GUIDE_MESSAGING]: null,
        [RestrictedCapability.GUIDANCE_SESSIONS]: null,
        [RestrictedCapability.OPEN_BANKING_ACCOUNT]: null,
        [RestrictedCapability.OPEN_INVESTMENT_ACCOUNT]: null,
    };

export const noAccessToRestrictedCapabilities: RestrictedCapabilityDictionary =
    {
        [RestrictedCapability.GUIDE_MESSAGING]: true, // we need to keep this enabled to prevent <GuideMessagingProvider> from remounting all children after the member finishes onboarding
        [RestrictedCapability.GUIDANCE_SESSIONS]: false,
        [RestrictedCapability.OPEN_BANKING_ACCOUNT]: false,
        [RestrictedCapability.OPEN_INVESTMENT_ACCOUNT]: false,
    };

export const fullAccessToRestrictedCapabilities: RestrictedCapabilityDictionary =
    {
        [RestrictedCapability.GUIDE_MESSAGING]: true,
        [RestrictedCapability.GUIDANCE_SESSIONS]: true,
        [RestrictedCapability.OPEN_BANKING_ACCOUNT]: true,
        [RestrictedCapability.OPEN_INVESTMENT_ACCOUNT]: true,
    };
